const getPricingContextVatInclusivity = () => {
  const doc = getDocument();
  return doc?.pcxtV3?.isVatInclusive() ?? "";
};
const getPricingContext = () => {
  const doc = getDocument();
  return doc?.pcxtV3?.getEncodedContextString() ?? "";
};
const isPricingContextInitialized = (developmentMode) => {
  const doc = getDocument();
  return developmentMode ? true : doc?.pcxtV3?.isInitialized() ?? false;
};
const getDocument = () => {
  return typeof document !== "undefined" ? document : void 0;
};

export { getPricingContext, getPricingContextVatInclusivity, isPricingContextInitialized };
//# sourceMappingURL=src-util-pricing-context.js.map
